
/**
 * Regex for partial CODE-128B input (Only accepts ascii from char code 32 to 127)
 */
export const CODE128B = /^[\x20-\x7F]+$/;

/**
 * List of each width for each section of a respective character in the barcode
 * First number will always be a solid line, and each number after alternates between blank and solid
 *
 * From: https://en.wikipedia.org/wiki/Code_128#Bar_code_widths
 */
export const PATTERNS = [
    [ 2, 1, 2, 2, 2, 2 ], // Ascii start
    [ 2, 2, 2, 1, 2, 2 ],
    [ 2, 2, 2, 2, 2, 1 ],
    [ 1, 2, 1, 2, 2, 3 ],
    [ 1, 2, 1, 3, 2, 2 ],
    [ 1, 3, 1, 2, 2, 2 ],
    [ 1, 2, 2, 2, 1, 3 ],
    [ 1, 2, 2, 3, 1, 2 ],
    [ 1, 3, 2, 2, 1, 2 ],
    [ 2, 2, 1, 2, 1, 3 ],
    [ 2, 2, 1, 3, 1, 2 ],
    [ 2, 3, 1, 2, 1, 2 ],
    [ 1, 1, 2, 2, 3, 2 ],
    [ 1, 2, 2, 1, 3, 2 ],
    [ 1, 2, 2, 2, 3, 1 ],
    [ 1, 1, 3, 2, 2, 2 ],
    [ 1, 2, 3, 1, 2, 2 ],
    [ 1, 2, 3, 2, 2, 1 ],
    [ 2, 2, 3, 2, 1, 1 ],
    [ 2, 2, 1, 1, 3, 2 ],
    [ 2, 2, 1, 2, 3, 1 ],
    [ 2, 1, 3, 2, 1, 2 ],
    [ 2, 2, 3, 1, 1, 2 ],
    [ 3, 1, 2, 1, 3, 1 ],
    [ 3, 1, 1, 2, 2, 2 ],
    [ 3, 2, 1, 1, 2, 2 ],
    [ 3, 2, 1, 2, 2, 1 ],
    [ 3, 1, 2, 2, 1, 2 ],
    [ 3, 2, 2, 1, 1, 2 ],
    [ 3, 2, 2, 2, 1, 1 ],
    [ 2, 1, 2, 1, 2, 3 ],
    [ 2, 1, 2, 3, 2, 1 ],
    [ 2, 3, 2, 1, 2, 1 ],
    [ 1, 1, 1, 3, 2, 3 ],
    [ 1, 3, 1, 1, 2, 3 ],
    [ 1, 3, 1, 3, 2, 1 ],
    [ 1, 1, 2, 3, 1, 3 ],
    [ 1, 3, 2, 1, 1, 3 ],
    [ 1, 3, 2, 3, 1, 1 ],
    [ 2, 1, 1, 3, 1, 3 ],
    [ 2, 3, 1, 1, 1, 3 ],
    [ 2, 3, 1, 3, 1, 1 ],
    [ 1, 1, 2, 1, 3, 3 ],
    [ 1, 1, 2, 3, 3, 1 ],
    [ 1, 3, 2, 1, 3, 1 ],
    [ 1, 1, 3, 1, 2, 3 ],
    [ 1, 1, 3, 3, 2, 1 ],
    [ 1, 3, 3, 1, 2, 1 ],
    [ 3, 1, 3, 1, 2, 1 ],
    [ 2, 1, 1, 3, 3, 1 ],
    [ 2, 3, 1, 1, 3, 1 ],
    [ 2, 1, 3, 1, 1, 3 ],
    [ 2, 1, 3, 3, 1, 1 ],
    [ 2, 1, 3, 1, 3, 1 ],
    [ 3, 1, 1, 1, 2, 3 ],
    [ 3, 1, 1, 3, 2, 1 ],
    [ 3, 3, 1, 1, 2, 1 ],
    [ 3, 1, 2, 1, 1, 3 ],
    [ 3, 1, 2, 3, 1, 1 ],
    [ 3, 3, 2, 1, 1, 1 ],
    [ 3, 1, 4, 1, 1, 1 ],
    [ 2, 2, 1, 4, 1, 1 ],
    [ 4, 3, 1, 1, 1, 1 ],
    [ 1, 1, 1, 2, 2, 4 ],
    [ 1, 1, 1, 4, 2, 2 ],
    [ 1, 2, 1, 1, 2, 4 ],
    [ 1, 2, 1, 4, 2, 1 ],
    [ 1, 4, 1, 1, 2, 2 ],
    [ 1, 4, 1, 2, 2, 1 ],
    [ 1, 1, 2, 2, 1, 4 ],
    [ 1, 1, 2, 4, 1, 2 ],
    [ 1, 2, 2, 1, 1, 4 ],
    [ 1, 2, 2, 4, 1, 1 ],
    [ 1, 4, 2, 1, 1, 2 ],
    [ 1, 4, 2, 2, 1, 1 ],
    [ 2, 4, 1, 2, 1, 1 ],
    [ 2, 2, 1, 1, 1, 4 ],
    [ 4, 1, 3, 1, 1, 1 ],
    [ 2, 4, 1, 1, 1, 2 ],
    [ 1, 3, 4, 1, 1, 1 ],
    [ 1, 1, 1, 2, 4, 2 ],
    [ 1, 2, 1, 1, 4, 2 ],
    [ 1, 2, 1, 2, 4, 1 ],
    [ 1, 1, 4, 2, 1, 2 ],
    [ 1, 2, 4, 1, 1, 2 ],
    [ 1, 2, 4, 2, 1, 1 ],
    [ 4, 1, 1, 2, 1, 2 ],
    [ 4, 2, 1, 1, 1, 2 ],
    [ 4, 2, 1, 2, 1, 1 ],
    [ 2, 1, 2, 1, 4, 1 ],
    [ 2, 1, 4, 1, 2, 1 ],
    [ 4, 1, 2, 1, 2, 1 ],
    [ 1, 1, 1, 1, 4, 3 ],
    [ 1, 1, 1, 3, 4, 1 ],
    [ 1, 3, 1, 1, 4, 1 ],
    [ 1, 1, 4, 1, 1, 3 ], // Ascii End
    [ 1, 1, 4, 3, 1, 1 ], // Special Chars Start (These are only used for checksum)
    [ 4, 1, 1, 1, 1, 3 ],
    [ 4, 1, 1, 3, 1, 1 ],
    [ 1, 1, 3, 1, 4, 1 ],
    [ 1, 1, 4, 1, 3, 1 ],
    [ 3, 1, 1, 1, 4, 1 ],
    [ 4, 1, 1, 1, 3, 1 ], // Special Chars End
];

// Start Code A [ 2, 1, 1, 4, 1, 2 ]
export const START_CODE_B = [ 2, 1, 1, 2, 1, 4 ];
// Start Code C [ 2, 1, 1, 2, 3, 2 ]
export const STOP_PATTERN = [ 2, 3, 3, 1, 1, 1, 2 ];
